import {
    changeLayout,
    changeLayoutWidth,
    changeLeftSidebarTheme,
    changeTopbarTheme,
    changeLeftSidebarType,
    showRightSidebar,
} from './utils';

import {
    CHANGE_LAYOUT,
    CHANGE_LAYOUT_WIDTH,
    CHANGE_SIDEBAR_THEME,
    CHANGE_SIDEBAR_TYPE,
    CHANGE_TOPBAR_THEME,
    SHOW_RIGHT_SIDEBAR,
    CHANGE_PRELOADER,
    TOGGLE_LEFTMENU,
    SHOW_SIDEBAR,
} from './actionTypes';

const INIT_STATE = {
    layoutType: 'vertical',
    layoutWidth: 'fluid',
    leftSideBarTheme: 'dark',
    leftSideBarType: 'default',
    topbarTheme: 'light',
    isPreloader: false,
    showRightSidebar: false,
    isMobile: false,
    showSidebar: true,
    leftMenu: false,
};

const Layout = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CHANGE_LAYOUT:
            changeLayout(action.payload);
            return {
                ...state,
                layoutType: action.payload,
            };
        case CHANGE_PRELOADER:
            return {
                ...state,
                isPreloader: action.payload,
            };

        case CHANGE_LAYOUT_WIDTH:
            changeLayoutWidth(action.payload);
            return {
                ...state,
                layoutWidth: action.payload,
            };
        case CHANGE_SIDEBAR_THEME:
            changeLeftSidebarTheme(action.payload);
            return {
                ...state,
                leftSideBarTheme: action.payload,
            };
        case CHANGE_SIDEBAR_TYPE:
            changeLeftSidebarType(action.payload);
            return {
                ...state,
                leftSideBarType: action.payload.sidebarType,
            };
        case CHANGE_TOPBAR_THEME:
            changeTopbarTheme(action.payload);
            return {
                ...state,
                topbarTheme: action.payload,
            };
        case SHOW_RIGHT_SIDEBAR:
            showRightSidebar(action.payload);
            return {
                ...state,
                showRightSidebar: action.payload,
            };
        case SHOW_SIDEBAR:
            return {
                ...state,
                showSidebar: action.payload,
            };
        case TOGGLE_LEFTMENU:
            return {
                ...state,
                leftMenu: action.payload,
            };
        default:
            return state;
    }
};

export default Layout;
